/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CommitteeViewDto } from './committeeViewDto';


export interface CommitteeViewWithParentDto { 
    id?: string;
    name: string;
    description?: string;
    photoId?: string;
    parentCommittees?: Array<CommitteeViewDto>;
    sortOrder?: number;
}

